import r from "./SharedContentErrorNode-DFwqwvbV.js";
import { resolveComponent as e, createBlock as n, openBlock as t } from "vue";
import { _ as a } from "./main-BMmugWNt.js";
const d = {
  name: "EditableSharedContentErrorNode",
  components: {
    SharedComponentErrorNode: r
  }
};
function p(c, m, s, _, f, i) {
  const o = e("SharedComponentErrorNode");
  return t(), n(o);
}
const C = /* @__PURE__ */ a(d, [["render", p]]);
export {
  C as default
};
